/**
 * Settings MV2 query API — isolated from MV1 pages/Settings.jsx.
 */
import api from "@/lib/api";

export const SETTINGS_CORE_QUERY_KEY = "settings-core";

export async function fetchSettingsCoreFromApi(signal) {
  const [opexRes, staffRes, sumRes, rosterGapsRes] = await Promise.allSettled([
    api.get("/opex-items"),
    api.get("/staff-members"),
    api.get("/staff-payroll/summary"),
    api.get("/staff-payroll/roster-gaps"),
  ]);
  if (signal?.aborted) throw new DOMException("Aborted", "AbortError");

  let opexItems = [];
  let opexTotal = 0;
  let opexFailed = false;
  if (opexRes.status === "fulfilled") {
    opexItems = opexRes.value.data.items || [];
    opexTotal = opexRes.value.data.total_monthly || 0;
  } else {
    opexFailed = true;
  }

  let staffList = [];
  let staffFailed = false;
  if (staffRes.status === "fulfilled") {
    staffList = staffRes.value.data.staff || [];
  } else {
    staffFailed = true;
  }

  let payrollSummaryMonths = [];
  if (sumRes.status === "fulfilled") {
    payrollSummaryMonths = sumRes.value.data.months || [];
  }

  let rosterGapsCount = 0;
  let rosterGapsFailed = false;
  if (rosterGapsRes.status === "fulfilled") {
    rosterGapsCount = rosterGapsRes.value.data.missing_count || 0;
  } else {
    rosterGapsFailed = true;
  }

  return {
    opexItems,
    opexTotal,
    staffList,
    payrollSummaryMonths,
    opexFailed,
    staffFailed,
    rosterGapsCount,
    rosterGapsFailed,
  };
}
